"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var shape = {
    borderRadius: 5,
    largeComponentRadius: 10,
    mediumComponentRadius: 5,
    smallComponentRadius: 2
};
var _default = exports.default = shape; //# sourceMappingURL=shape.js.map
